import React from "react";
import Router from "./Router";

export default function MainPage() {
  return (
    <div>
      <div className="content-wrapper">
        <Router />
      </div>
    </div>
  );
}
